import React from 'react';
import { newGuid } from 'components/Form/ValidationElement';
import { ErrorCode } from '@redux/modules/application/reducers/error';

export interface SubsectionProps {
  onError?: (value: any, arr: ErrorCode[]) => ErrorCode[]
}

export default class SubsectionElement<P extends SubsectionProps, S = {}> extends React.Component<
  P,
  S
> {
  section = '';

  subsection = '';

  store = '';

  storeKey = '';

  static defaultProps = {
    onError: (value: any, arr: ErrorCode[]): ErrorCode[] => arr,
  };

  constructor(props: P) {
    super(props);

    this.handleError = this.handleError.bind(this);
  }

  handleError(value: any, arr: ErrorCode[]) {
    const { onError } = this.props;

    /* eslint no-param-reassign: 0 */
    arr = arr.map((err) => ({
      ...err,
      // note the original subsection the field is associated with, as it could
      // be appearing under 'review'
      section: this.section,
      subsection: this.subsection,
    }));
    /* eslint no-param-reassign: 1 */

    return onError?.(value, arr);
  }

  guid() {
    return newGuid();
  } // eslint-disable-line
}
